import { Outlet } from "react-router-dom";

export default function LoginLayout() {

  return (
    <div className=" sm:flex sm:flex-col lg:grid lg:grid-cols-7 h-screen">
      <div
        className="col-span-3 lg:h-full sm:h-1/6 flex flex-col justify-between w-full bg-primaryVar lg:relative"
        dir="rtl"
      >
        <div className=" md:hidden sm:hidden lg:flex lg:flex-col gap-5 text-white text-center p-20 z-50">
          <h2 className=" font-bold text-lg">به ادمین پنل داناجو خوش آمدی</h2>
          <span className=" text-justify ">
            داناجو شبکه اجتماعی تخصصی در حوزه آموزش است که به شما امکان تولید و
            فروش آموزش رو به صورت ویدئویی، متنی، پادکست و مقاله میده، اینجا صفحه
            شخصی خودت رو داری و میتونی از طریق پیام رسان با سایر دانشجو ها و
            اساتید در ارتباط باشی
          </span>

        </div>
      </div>
      <div className="col-span-4 bg-backgroundPrimary">
        <Outlet />
      </div>
    </div>
  );
};